import React from 'react';
import IconButton from 'components/generics/IconButton';
import Edit from 'components/pages/Home/Edit';
// import Delete from 'components/icons/Delete';

const FunctionsCategoriesTable  = props => (
    <table>
      <thead>
        <tr>
          <th>Nom</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {props.functionsCategories.length > 0 ? (
          props.functionsCategories.map(item => (
            <tr key={item.id}>
              <td>{item.name}</td>
              <td className="actionner">
                <IconButton onClick={() => props.editRow(item)} icon={<Edit  />} />
                {/* <IconButton  onClick={() => props.handleDeleteFunctionsCategories(item.id)} icon={<Delete  />} /> */}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={3}>Pas de statut pour les devis</td>
          </tr>
        )}
      </tbody>
    </table>
  )
  

export default FunctionsCategoriesTable;
